<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<v-form ref="form">
							<v-row dense>
								<v-col cols="12">
									<v-combobox
										v-model="params.category"
										:items="categories"
										label="Категорія"
										outlined
										dense
										item-text="name"
										item-value="id"
										hide-details="auto"
										:loading="loadings.category"
										:rules="[rules.required, rules.onlyFromList]"
										@change="onCategory"
										@focus="focusCategory"
									></v-combobox>
								</v-col>
								<v-col cols="12">
									<v-combobox
										v-model="params.brand"
										:items="brands"
										label="Марка"
										outlined
										dense
										item-text="name"
										item-value="id"
										hide-details="auto"
										:loading="loadings.brand"
										:rules="[rules.required, rules.onlyFromList]"
										@change="onBrand"
										@focus="focusBrand"
									></v-combobox>
								</v-col>
								<v-col cols="12">
									<v-combobox
										v-model="params.model"
										:items="models"
										label="Модель"
										outlined
										dense
										item-text="name"
										item-value="id"
										hide-details="auto"
										:loading="loadings.model"
										:rules="[rules.required]"
										@change="onModel"
										@focus="focusModel"
									></v-combobox>
								</v-col>
								<v-col cols="12">
									<v-combobox
										v-model="params.yearProd"
										:items="years"
										label="Рік випуску авто"
										outlined
										dense
										hide-details="auto"
										:loading="loadings.year"
										:rules="[rules.required]"
										@focus="focusYear"
									></v-combobox>
								</v-col>
								<v-col cols="12">
									<v-select
										v-model="params.type"
										:items="types"
										label="Категорія за об'ємом двигуна"
										item-text="name"
										item-value="code"
										outlined
										dense
										hide-details="auto"
										return-object
										:rules="[rules.required]"
									>
										<template v-slot:item="{ on, item }">
											<v-list-item v-on="on">
												<v-list-item-content>
													<v-list-item-title>{{ item.name }}</v-list-item-title>
													<v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</template>
									</v-select>
								</v-col>
							</v-row>
						</v-form>
					</v-form>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<!-- PDF -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>

				<!-- Excel -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->

				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon v-bind="attrs" v-on="{ ...tooltip }" @click="notEmpty=!notEmpty">{{ notEmpty ? 'mdi-circle-half-full' : 'mdi-moon-full' }}</v-icon>
							</template>
							<span v-if="notEmpty">Зі значенням</span>
							<span v-else>Всі дані</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->
			</v-list>
        </v-navigation-drawer>

		
		<v-container style="padding: 64px 0px 0px 256px;">
			<v-breadcrumbs :items="crumbs" divider="-" ></v-breadcrumbs>
		
			<v-card flat>
				<v-card-title class="font-weight-light">
					{{ title }}
				</v-card-title>

				<v-divider></v-divider>

				<v-card-text>
					<!-- <v-data-table v-if="equipments.length"
						:headers="headers"
						:items="equipments"
						hide-default-footer
						disable-pagination
					></v-data-table> -->


					<!-- <v-list dense>
						<v-list-item>
							<v-list-item-content>
								<v-list-item-title>UAH</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<v-list-item-action-text class="font-weight-bold text-subtitle-2">{{ data.avgPriceUAH | toCurrencyUAH }}</v-list-item-action-text>
							</v-list-item-action>
						</v-list-item>
						<v-list-item>
							<v-list-item-content>
								<v-list-item-title>USD</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<v-list-item-action-text class="font-weight-bold text-subtitle-2">{{ data.avgPriceUSD | toCurrencyUSD }}</v-list-item-action-text>
							</v-list-item-action>
						</v-list-item>
					</v-list> -->

					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-left">Валюта</th>
									<th class="text-left">Мінімальна</th>
									<th class="text-left">Середня</th>
									<th class="text-left">Максимальна</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>UAH</td>
									<td>{{ data.minPriceUAH | toMoney }}</td>
									<td class="font-weight-bold text-subtitle-2">{{ data.avgPriceUAH | toMoney }}</td>
									<td>{{ data.maxPriceUAH | toMoney }}</td>
								</tr>
								<tr>
									<td>USD</td>
									<td>{{ data.minPriceUSD | toMoney }}</td>
									<td class="font-weight-bold text-subtitle-2">{{ data.avgPriceUSD | toMoney }}</td>
									<td>{{ data.maxPriceUSD | toMoney }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</v-card-text>
			</v-card>
		</v-container>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<z-pdf ref="pdf" :code="code" :name="name"></z-pdf>
	</v-main>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import mixin from './mixin/main'

export default {
	//name: 'Report::VehicleMarketValue',
	mixins: [mixin],
	components: { },
	data: () => ({
		minYear: 1900,
		maxYear: (new Date()).getFullYear(),

		loadings: {
			category: false,
			brand: false,
			model: false,
			year: false,
		},

		/* headers: [
			{ text: 'Код', value: 'VariableId' },
			{ text: 'Назва', value: 'Variable' },
			{ text: 'Значення', value: 'Value' },
		], */

		types: [
			//{ code: 'А1' title: 'А1', subtitle: 'Мотоцикл — до 300 см³', icon: '', engineVolumeFrom: 0,  engineVolumeTo: 0.03 },
			//{ code: 'А2', title: 'А2', subtitle: 'Mоторолер — понад 300 см³', icon: '', engineVolumeFrom: 0.03,  engineVolumeTo: 1.1000 },
			/* { code: 'В1', title: 'В1 - Легкове авто', subtitle: "Об'єм двигуна до 1600 см³", icon: 'mdi-car-convertible', engineVolumeFrom: 0,  engineVolumeTo: 1.6000 },
			{ code: 'В2', title: 'В2 - Легкове авто', subtitle: "Об'єм двигуна 1601-2000 см³", icon: 'mdi-car-hatchback', engineVolumeFrom: 1.601,  engineVolumeTo: 2.0000 },
			{ code: 'В3', title: 'В3 - Легкове авто', subtitle: "Об'єм двигуна 2001-3000 см³", icon: 'mdi-car-hatchback', engineVolumeFrom: 2.001,  engineVolumeTo: 3.000 },
			{ code: 'В4', title: 'В4 - Легкове авто', subtitle: "Об'єм двигуна понад 3000 см³", icon: 'mdi-car-estate', engineVolumeFrom: 3.001,  engineVolumeTo: 4.000 },
			 */
			{ code: 'В1', name: 'В1 - Легкове авто', description: "Об'єм двигуна до 1,6 л", icon: 'mdi-car-convertible', engineVolumeFrom: 0,  engineVolumeTo: 1.6000 },
			{ code: 'В2', name: 'В2 - Легкове авто', description: "Об'єм двигуна 1,6-2 л", icon: 'mdi-car-hatchback', engineVolumeFrom: 1.601,  engineVolumeTo: 2.0000 },
			{ code: 'В3', name: 'В3 - Легкове авто', description: "Об'єм двигуна 2-3 л", icon: 'mdi-car-hatchback', engineVolumeFrom: 2.001,  engineVolumeTo: 3.000 },
			{ code: 'В4', name: 'В4 - Легкове авто', description: "Об'єм двигуна понад 3 л", icon: 'mdi-car-estate', engineVolumeFrom: 3.001,  engineVolumeTo: 4.000 },
			
			//{ code: 'С1', title: 'С1', subtitle: 'Вантажне авто — до 2 т', icon: '' },
			//{ code: 'С2', title: 'С2', subtitle: 'Вантажне авто — понад 2 т', icon: '' },
			//{ code: 'D1', title: 'D1', subtitle: 'Автобус — до 20 осіб', icon: '' },
			//{ code: 'D2', title: 'D2', subtitle: 'Автобус — 21 особа і більше', icon: '' },
			//{ code: 'F', title: 'F', subtitle: 'Причіп — для легкових ТЗ', icon: '' },
			//{ code: 'F2', title: 'F2', subtitle: 'Трейлер — для вантажних ТЗ', icon: '' },
			//{ code: 'V1', title: 'V1', subtitle: 'Електромобіль', icon: '' },
		],
	}),

	props: {
		code: 				{ type: String, default: 'VehicleMarketValue' },
		name: 				{ type: String, default: 'Ринкова ціна транспортного засобу' },
		//vin: 				{ type: String },
	},


	computed: {
		//...mapGetters('ReportVehicleMarketValue', ['params', 'data']),
		...mapGetters('VehicleCategory', { categories: 'items' }),
		...mapGetters('VehicleBrand', { brands: 'items' }),
		...mapGetters('VehicleBrandModel', { models: 'items' }),
		...mapGetters('VehicleBrandModelYear', { years: 'items' }),

		/* years() {
			const arrayRange = (start, stop, step) =>
			Array.from(
				{ length: (stop - start) / step + 1 },
				(value, index) => start + index * step
			);
			return arrayRange(this.minYear, this.maxYear, 1).reverse();
		}, */

		engineVolumeFrom() {
			return this.params?.type?.engineVolumeFrom ? this.params.type.engineVolumeFrom : 0
		},

		engineVolumeTo() {
			return this.params?.type?.engineVolumeTo ? this.params.type.engineVolumeTo : 5
		},
	},

	created () {
		//console.log(this.$options.name, 'created')
		delete this.params.datebegin;
		delete this.params.dateend;

		this.params.type = this.types[0];

		this.focusCategory()?.then(() => this.$set(this.params, 'category', this.categories[0]))
	},

	methods: {
		...mapActions('ReportVehicleMarketValue', { setData: 'setData'}),
		...mapActions('VehicleCategory', { loadCategory: 'load'}),
		...mapActions('VehicleBrand', { loadBrand: 'load', setBrands: 'setItems' }),
		...mapActions('VehicleBrandModel', { loadModel: 'load', setModels: 'setItems' }),
		...mapActions('VehicleBrandModelYear', { loadYear: 'load', setYears: 'setItems' }),


		clearBrand () {
			this.$set(this.params, 'brand', null)
			this.setBrands()

			this.clearModel()
		},

		clearModel () {
			this.$set(this.params, 'model', null)
			this.setModels()
		},

		clearYear () {
			this.$set(this.params, 'yearProd', null)
			this.setYears()
		},

		onCategory (item) {
			this.clearBrand()
		},

		onBrand (item) {
			this.clearModel()
		},

		onModel (item) {
			this.clearYear()
		},

		focusCategory(e) {
			if(this.categories.length == 0) {
				this.loadings.category = true
				return this.loadCategory(this.params).finally(() => (this.loadings.category = false));
			}
		},

		focusBrand() {
			if(this.params?.category?.id && this.brands.length == 0) {
				this.loadings.brand = true
				this.loadBrand(this.params).finally(() => (this.loadings.brand = false));
			}
		},

		focusModel() {
			if(this.params?.category?.id && this.params?.brand?.id && this.models.length == 0) {
				this.loadings.model = true
				this.loadModel(this.params).finally(() => (this.loadings.model = false));
			}
		},

		focusYear() {
			if(this.params?.model?.id) {
				this.loadings.year = true
				this.loadYear(this.params).finally(() => (this.loadings.year = false));
			}
		},

		


		onOK() {
			var that = this

			this.params['engineVolumeFrom'] = this.engineVolumeFrom
			this.params['engineVolumeTo'] = this.engineVolumeTo

			this.clearData()

			if (this.$refs.form.validate()) {
				//console.log(this.$options.name, 'param', this.params)

				this.loading = true
				axios.post(`/vehicle/market/value`, this.params).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					that.setData(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
				});
			}
		},

		clearData() {
			this.setData({})
			/* this.setData({
				datasets: {
					ds: {},
					ds2: {},
				}
			}) */
		},
	},
}
</script>